import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FormatterRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/resources-modules/formatter/formatter-routing.module.ts